<template>
    <div>
        <b-col cols="12" class="d-flex justify-content-end">
            <b-button id="add-item-btn" variant="pink-button" v-b-tooltip.hover :title="$addLabel()"
                v-if="user_permissions.includes('create.activity.templates')" @click="addItem">
                <img src="@/assets/images/icon/gradient-add.svg" />
            </b-button>
        </b-col>

        <b-overlay :show="loading" rounded="sm">
            <b-modal no-close-on-backdrop v-model="itemModal" id="item-modal" header-class="p-0"
                footer-class="d-flex justify-content-center border-0" @close="removeItems"
                content-class="primary-items custom-model-wrap" @ok="saveTemplateItem">
                <template #modal-title="{ cancel }">
                    <div class="title-block text-center p-2">
                        {{
                            `${model.id || model.index
                                ? $translate('edit')
                                : $translate('add')
                                } ${$translate('item')}`
                        }}
                    </div>
                    <div class="close-btn" @click="cancel()">x</div>
                </template>
                <!-- <b-overlay :show="loading" rounded="sm"> -->
                <b-form bg-variant="light">
                    <b-form-row v-if="!model.id &&
                        user_permissions.includes('view.activity.templates')
                        ">
                        <b-col cols="4">
                            <label class="font-weight-bold pt-0 mb-2"><strong>{{
                                $translate('search_item')
                            }}</strong></label>
                        </b-col>
                        <b-col>
                            <!-- {{ templateItems }} -->
                            <vue-typeahead-bootstrap ref="templateSearch" :types="types" v-model="searchMasterItem"
                                @order_item_type_id="order_item_type_id" @queryOptionsValue="queryOptionsValue"
                                :data="masterItems" :serializer="s =>
                                    s.name +
                                    ', ' +
                                    s.description +
                                    ', ' +
                                    s.type.name
                                    " @hit="getMasterItem" @input="lookupMasterItems"
                                :placeholder="$translate('search_master_item')" />
                        </b-col>
                        <b-table v-if="templateItems.length" id="roleTable" responsive v-model="tableData"
                            :items="templateItems" :fields="tableFields">
                            <template #cell(id)="row">
                                <b-button  v-if="hasPermissionView" @click="deleteGenratedTemplateItem(row.item)"
                                    class="me-2 test-delete-item-template-btn" variant="pink-button">
                                    <img src="@/assets/images/icon/delete.svg" />
                                </b-button>
                            </template>
                            <template #cell(default_quantity)="{ item, index }">
                                <b-form-input required type="number" v-model="item.default_quantity"
                                    v-custom-validation="$textRequired()" min="0" class="form-control test-default-quantity"></b-form-input>
                            </template>
                            <template #cell(customer_completion)="{ item, index }">
                                <b-form-checkbox v-model="item.customer_completion" :value="1" :unchecked-value="0" >
                                </b-form-checkbox>
                            </template>
                        </b-table>
                    </b-form-row>
                    <div class="mt-3" v-else>
                        <h6>
                        </h6>
                        <div class="mt-3" v-if="masterItemFields.length > 0">
                            <h6>
                                <strong>{{ $translate('master_item') }}</strong>
                            </h6>
                            <b-form-row class="d-flex master-item-text-bold" v-for="(x, i) in masterItemFields"
                                :key="i + 'master-item---'">
                                <b-col cols="4"><label class="font-weight-bold pt-2"><strong>{{
                                    $translate(x.key.toLowerCase())
                                }}:</strong></label></b-col>
                                <p>
                                    {{ x.value }}
                                </p>
                                <b-col></b-col>
                            </b-form-row>
                            <b-col cols="12">
                                <label class="mb-3"><strong>{{
                                    $translate('default_quantity')
                                }}</strong></label>
                                <b-form-input type="number" id="input-default_quantity" v-model="model.default_quantity"
                                    required :placeholder="$translate('enter_default_quantity')" trim></b-form-input>
                            </b-col>
                           
                            <b-col cols="12">
                                <label class="mb-3"><strong>{{
                                    $translate('customer_completion')
                                }}</strong></label>
                                <b-form-checkbox type="number" id="input-default_quantity"  :value="1" :unchecked-value="0" v-model="model.customer_completion"
                                    required  trim></b-form-checkbox>
                            </b-col>
                        </div>
                    </div>
                </b-form>
                <template #modal-footer="{ ok, close }">
                    <b-button
                        id="create-update-item-btn"
                        :disabled="model.id ? masterItemFields.length === 0 || !modelChanged : templateItems.length === 0"
                        variant="info" class="btn btn-info btn-fw me-2" @click="ok()">
                        {{
                            `${!!model.index || !!model.id
                                ? $updateLabel()
                                : $createLabel()
                                } ${$translate('item')}`
                        }}
                    </b-button>
                    <b-button id="delete-item-btn" v-if="hasPermissionDelete && (model.id || model.index)" class="me-2" size="fw"
                        variant="delete-button" @click="deleteTemplateItem()">
                        {{ $deleteLabel() }}
                    </b-button>
                    <b-button id="close-item-btn" variant="info" class="btn-fw" @click="close()">
                        {{ $cancelLabel() }}
                    </b-button>
                </template>

                <!-- </b-overlay> -->
            </b-modal>
        </b-overlay>
        <div class="table-responsive mt-2">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>{{ $translate('actions') }}</th>
                        <th>{{ $translate('name') }}</th>
                        <th>{{ $translate('code') }}</th>
                        <th>{{ $translate('qty') }}</th>
                        <th>{{ $translate('uom') }}</th>
                        <th>{{ $translate('price') }}</th>
                        <th>{{ $translate('type') }}</th>
                        <th>{{ $translate('customer_completion') }}</th>
                    </tr>
                </thead>
                <draggable tag="tbody" @end="onDragEnd" :options="draggableOptions" class="draggable-table">
                    <tr v-for="item in items" :key="item.id" class="draggable-item">
                        <td>
                            <b-button :id="'view-item-btn-'+item.id" @click="viewItem(item.id || row.item.index)" class="me-2 test-view-item-btn" variant="pink-button">
                                <img src="@/assets/images/icon/view.svg" />
                            </b-button>
                        </td>
                        <td>{{ item.master_item.name }}</td>
                        <td>{{ item.master_item.ext_reference_code, }}</td>
                        <td>{{ item.default_quantity }}</td>
                        <td>{{ item.master_item.uom }}</td>
                        <td>{{ item.master_item.selling_price }}</td>
                        <td>{{ item.master_item.type.name }}</td>
                        <td>{{ item.customer_completion ? 'Yes' : 'No' }}</td>

                    </tr>
                </draggable>
            </table>
        </div>
    </div>
</template>
<script>
import draggable from 'vuedraggable'
import VueTypeaheadBootstrap from '@/components/templateItemVueTypeAhead/VueTypeaheadBootstrap'
import { debounce } from 'lodash'
import permissionsMixins from '@/mixins/permissionsMixins'
import popupMixins from '@/mixins/popupMixins'

// import { capitalCase } from 'change-case'
const itemFields = [
    'ext_reference_code',
    'name',
    'description',
    'uom',
    'selling_price',
    'active',
    'vendor_id',
    'order_item_type_id',
]
export default {
    name: 'activityTemplates-templateitems',
    props: ['isSecondaryOrderType', 'tabIdx'],
    mixins: [permissionsMixins, popupMixins],
    components: { VueTypeaheadBootstrap, draggable },
    data() {
        return {
            display: 'Table',
            order: 8,
            draggableOptions: {
                animation: 300,
            },
            quantityData: [],
            tableData: [],
            searchMasterItem: '',
            model: {},
            filters: { queryOptionsValue: 'starts_with' },
            loading: false,
            itemModal: false,
            masterItemFields: [],
            modelChanged: false,
        }
    },
    computed: {
        itemFields() {
            return [
                {
                    key: 'id',
                    label: '',
                },
                {
                    key: 'master_item_id',
                    label: this.$translate('name'),
                    formatter: (value, key, item) => item.master_item.name,
                },
                {
                    key: 'ext_reference_code',
                    label: this.$translate('code'),
                    formatter: (value, key, item) =>
                        item.master_item.ext_reference_code,
                },
                {
                    key: 'default_quantity',
                    label: this.$translate('qty'),
                },
                {
                    key: 'uom',
                    label: this.$translate('uom'),
                    formatter: (value, key, item) => item.master_item.uom,
                },
                {
                    key: 'selling_price',
                    label: this.$translate('price'),
                    formatter: (value, key, item) =>
                        item.master_item.selling_price,
                },
                {
                    key: 'order_item_type_id',
                    label: this.$translate('type'),
                    formatter: (value, key, item) => item.master_item.type.name,
                },
            ]
        },
        tableFields() {
            return [
                {
                    key: 'id',
                    label: this.$translate('actions'),
                },
                {
                    key: 'master_item_id',
                    label: this.$translate('name'),
                    formatter: (value, key, item) => item.name,
                    class: "text-wrap"
                },
                {
                    key: 'ext_reference_code',
                    label: this.$translate('code'),
                    formatter: (value, key, item) =>
                        item.ext_reference_code,
                },
                {
                    key: 'uom',
                    label: this.$translate('uom'),
                    formatter: (value, key, item) => item.uom,
                },
                {
                    key: 'selling_price',
                    label: this.$translate('price'),
                    formatter: (value, key, item) =>
                        item.selling_price,
                },
                {
                    key: 'order_item_type_id',
                    label: this.$translate('type'),
                    formatter: (value, key, item) => item.type.name,
                },
                {
                    key: 'default_quantity',
                    label: this.$translate('default_quantity'),
                },
                {
                    key: 'customer_completion',
                    label: this.$translate('customer_completion'),
                },
            ]
        },
        templateItems() {
            console.log("this.$store.state.masterItem", this.$store.state.masterItem)
            return this.$store.state.masterItem.template_items
        },
        masterItems() {
            return this.$store.state.masterItem.items
        },
        masterItem() {
            return this.$store.state.masterItem.item
        },
        types() {
            return this.$store.state.itemType.items.filter(x => !x.is_discount)
        },
        submitLabel() {
            if (this.loading && this.model.id) {
                return this.$translate('updating')
            } else if (this.loading) {
                return this.$translate('creating')
            } else if (this.model.id) {
                return this.$updateLabel()
            } else {
                return this.$createLabel()
            }
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },

        template() {
            return this.$store.state.orderTemplate.selectedTemplate
        },

        items() {
            const { isSecondaryOrderType, template } = this
            console.log('itemm', isSecondaryOrderType, template.items)
            return (template.items || []).filter(
                x => x.is_secondary_order_type == isSecondaryOrderType
            )
        },
    },
    watch: {
        'model.default_quantity': function (to, from) {
            if (from >= 0) this.modelChanged = true
        },
        'model.customer_completion': function (to, from) {
            if (from >= 0) this.modelChanged = true
        },
    },

    mounted() {
        this.$store.dispatch("itemType/fetchAll");
        console.log('masterItems', this.masterItems)
    },
    methods: {
        async removeItems() {
            this.$refs.templateSearch && this.$refs.templateSearch.resetInput()
            await this.$store.commit('masterItem/SET_TEMPLATE_ITEMS', [])
        },
        async onDragEnd(event) {
            this.items.splice(
                event.newIndex,
                0,
                this.items.splice(event.oldIndex, 1)[0]
            )
            this.items.forEach(function (items, index) {
                items.order = index
            })
            const templateItems = this.items
            const id = this.template.id
            await this.$store
                .dispatch('orderTemplate/updateItemOrder', {
                    templateItems,
                    id,
                })
            this.doToast(
                this.$translate('success'),
                this.$translate(`template_sequence`),
                'success'
            )

        },
        queryOptionsValue(val) {
            this.filters.queryOptionsValue = val
            this.lookupMasterItems()
        },
        order_item_type_id(val) {
            console.log("filters gett", val)
            this.filters.order_item_type_id = val
            this.lookupMasterItems()
        },

        lookupMasterItems: debounce(function () {
            // in practice this action should be debounced
            const query = this.searchMasterItem
            const filters = {
                is_product_only: this.isSecondaryOrderType ? 1 : 0,
                queryOptionsValue: this.filters.queryOptionsValue,
                order_item_type_id: this.filters.order_item_type_id
            }
            this.$store.dispatch('masterItem/fetchAll', {
                query,
                filters,
            })
        }, 500),

        getMasterItem(item) {
            //make array empty
            this.masterItemFields.splice(0)
            console.log('masterItemFields--item', item)
            if (!item) return
            this.searchMasterItem = null
            this.modelChanged = !this.model.id
            this.model.master_item_id = item.id
            // add the master item information to the model
            this.model.master_item = { ...item }
            for (let x of itemFields) {
                let key, value
                switch (x) {
                    case 'vendor_id': {
                        key = 'Vendor'
                        value = item.vendor && item.vendor.name
                        break
                    }
                    case 'order_item_type_id': {
                        key = 'Type'
                        value = item.type && item.type.name
                        break
                    }
                    case 'ext_reference_code': {
                        key = 'Code'
                        value = item[x]
                        break
                    }
                    case 'active': {
                        key = 'Active'
                        value = !!item[x]
                        break
                    }
                    default: {
                        key = x
                        value = item[x]
                    }
                }
                this.masterItemFields.push({ key, value })
            }
        },
        addItem() {
            this.masterItemFields.splice(0)
            this.model = {
                id: null,
                default_quantity: null,
                master_item_id: null,
            }
            this.itemModal = true
        },
        async deleteGenratedTemplateItem(item) {
            await this.$store.dispatch('masterItem/deleteTemplateItem', item)
        },
        async viewItem(templateId) {
            /* if the template exists find the item among the template's 
            items otherwise, firnd the item among the template model's items */
            const templateItem =
                this.template.items.find(x => x.id === templateId) || {}

            const { master_item_id } = templateItem

            this.model = { ...templateItem }

            if (this.template.id) {
                await this.$store.dispatch(
                    'masterItem/fetchById',
                    master_item_id
                )
                await this.$nextTick()
                this.getMasterItem(this.masterItem)
            } else {
                this.getMasterItem(templateItem.master_item)
            }
            this.itemModal = true
        },
        deleteTemplateItem() {
            this.loading = true
            // if the template exists delete the master item from the database
            if (this.template.id) {
                const path = `orderTemplate/deleteItem`
                const template_id = this.template.id
                const toastTitle = this.isSecondaryOrderType
                    ? this.$translate('secondary_item')
                    : this.$translate('primary_item')

                const item_id = this.model.id
                this.$store
                    .dispatch(path, { template_id, item_id })
                    .then(() => {
                        this.loading = false
                        this.itemModal = false
                        this.modelChanged = false
                        this.genericToast(
                            `${toastTitle}`,
                            this.$translate('deleted'),
                            'success',
                            `${toastTitle} ${this.$translate('delete_alert')}`
                        )
                    })
                    .catch(error => {
                        console.log('error', error)
                        this.doToast(this.$translate("error"), error.message, "danger");
                    })  
                    .finally(() => {
                        this.loading = false
                    })
            } else {
                // if this is a new template, delete the master item from the template moel
                this.template_model.items.splice(this.model.index - 1, 1)

                // reindex the items
                for (var i = 1; i <= this.template_model.items.length; i++) {
                    this.template_model.items[i - 1].index = i
                }
                this.loading = false
                this.itemModal = false
                this.modelChanged = false
            }
        },
        saveTemplateItem(bvModalEvt) {
            bvModalEvt.preventDefault()
            let model, item
            if (this.templateItems.length) {
                const { isSecondaryOrderType: is_secondary_order_type } = this
                item = [...this.tableData]
                const template_id = this.template.id
                model = { item, template_id, is_secondary_order_type }
            } else {
                const { isSecondaryOrderType: is_secondary_order_type } = this
                item = { ...this.model, is_secondary_order_type }
                item.default_quantity = item.default_quantity || 0
                const template_id = this.template.id
                model = { template_id, item }
            }
            // success Toast fields for update and create for primary and secondary item
            const toastTitle = this.isSecondaryOrderType
                ? this.$translate('secondary_item')
                : this.$translate('primary_item')
            const action = item.id
                ? this.$translate('updated')
                : this.$translate('created')
            const message = item.id
                ? this.$translate('updated')
                : this.$translate('created')

            if (this.template.id) {
                // if the template exists add the master item to the template in the database or update it in the database
                const path = `orderTemplate/${parseInt(item.id) ? 'updateItem' : 'createItem'
                    }`

                this.loading = true
                this.$store
                    .dispatch(path, model)
                    .then(() => {
                        this.loading = false
                        this.itemModal = false
                        this.modelChanged = false
                        this.removeItems()
                        this.genericToast(
                            `${toastTitle}`,
                            action,
                            'success',
                            `${toastTitle} ${message}`
                        )
                    })
                    .catch(error => {
                        this.doToast(this.$translate('error'), error.message, 'danger')
                    })
                    .finally(() => {
                        this.loading = false
                    })
            } else {
                // if the template does not exist add the master item to or update it in the template model's item list
                if (model.item.should_update) {
                    this.loading = true
                    model.item.should_update = true

                    this.template_model.items.splice(
                        model.item.index - 1,
                        1,
                        model.item
                    )
                    this.itemModal = false
                    this.modelChanged = false
                    this.loading = false
                } else {
                    this.loading = true
                    model.item.should_update = true
                    var index = this.template_model.items.push(model.item)

                    this.template_model.items[index - 1].index = index

                    this.itemModal = false
                    this.modelChanged = false
                    this.loading = false
                }
                this.genericToast(
                    `${toastTitle}`,
                    action,
                    'success',
                    `${toastTitle} ${message}`
                )
            }

        },
    },
}
</script>